var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWowTierListIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.333 8.662v1.343h1.344V8.662zM0 7.33h4v4.007H0zm1.333-5.328v1.352h1.344V2.002zM0 .67h4v4.006H0zm5.333 9.325h4v1.352h-4zm0-2.665H12v1.343H5.333zm0-3.996h4v1.342h-4zm0-2.664H12v1.342H5.333z"
  })));
}
export default __webpack_public_path__ + "static/svg/wow-tier-list-icon.svg";
export { SvgWowTierListIcon as ReactComponent };